<template>
  <div class="m-page-footer" :class="{ 'rtl--container': isArSite }">
    <div class="m-footer-wrapper">
      <div class="m-menu-group-header" @click="onExpandMenu('GSC')">
        <div class="left">
          {{ $t('GSC') }}
        </div>
        <div class="right">
          <UpDown mode="dark" :type="getType('GSC')" />
        </div>
      </div>
      <div v-show="isExpand('GSC')">
        <div v-for="l in getLinks('1')" :key="l.id" class="m-menu-item" @click="e => openUrl(l.linkUrl, e)">
          {{ l.linkTitle }}
        </div>
      </div>
      <div class="m-menu-group-header" @click="onExpandMenu('HSC')">
        <div class="left">
          {{ $t('HSC') }}
        </div>
        <div class="right">
          <UpDown mode="dark" :type="getType('HSC')" />
        </div>
      </div>
      <div v-show="isExpand('HSC')">
        <div v-for="l in getLinks('2')" :key="l.id" class="m-menu-item" @click="e => openUrl(l.linkUrl, e)">
          {{ l.linkTitle }}
        </div>
      </div>
      <div class="m-menu-group-header" @click="onExpandMenu('Quick Links')">
        <div class="left">
          {{ $t('footer.quickLinks') }}
        </div>
        <div class="right">
          <UpDown mode="dark" :type="getType('Quick Links')" />
        </div>
      </div>
      <div v-show="isExpand('Quick Links')">
        <div v-for="l in getLinks('3')" :key="l.id" class="m-menu-item" @click="e => openUrl(l.linkUrl, e)">
          {{ l.linkTitle }}
        </div>
      </div>
      <div class="m-menu-group-header" @click="onExpandMenu('Related Links')">
        <div class="left">
          {{ $t('footer.relatedLinks') }}
        </div>
        <div class="right">
          <UpDown mode="dark" :type="getType('Related Links')" />
        </div>
      </div>
      <div v-show="isExpand('Related Links')">
        <div v-for="l in getLinks('4')" :key="l.id" class="m-menu-item" @click="e => openUrl(l.linkUrl, e)">
          {{ l.linkTitle }}
        </div>
      </div>
      <div v-if="showCooperativePartner" class="m-parterner">
        <div class="title">
          {{ $t('footer.strategicPartners') }}:
        </div>
        <div class="list-items">
          <div v-for="l in getLinks('5')" :key="l.id" class="list-item">
            <a :href="l.linkUrl" target="_blank"><img :src="l.linkImage" style="max-height: 3.2rem;max-width:4.8rem;"></a>
          </div>
        </div>
      </div>
      <div class="m-menu-group-header m-menu-default-expanded">
        <div class="left">
          {{ $t('footer.contactUs') }}
        </div>
        <div class="m-menu-content">
          <span>{{ $t('footer.pleaseContact') }}</span>
          <a :href="`mailto:${$t('footer.contactEmail')}`" style="color: #1585FF">{{ $t('footer.contactEmail') }}</a>
          <!-- <div class="join-us-desc">
            {{ $t('footer.joinTeamDesc') }}
          </div>
          <div @click="joinUs" class="join-us-btn">
            <span>{{ $t('footer.joinUs') }}</span>
          </div> -->
        </div>
      </div>
      <!-- <div v-if="!showCooperativePartner" class="m-divider" /> -->
      <div class="m-site-links">
        <div v-for="(linkItem, index) in socialSiteUrl" :key="`${linkItem.id}_${index}`" class="link-item">
          <a
            v-if="linkItem.socialMediaList && linkItem.socialMediaList.length === 1"
            v-at-navigation="`footer::social::${linkItem.socialMediaList?.[0].title}`"
            class="link-label"
            :href="linkItem.socialMediaList?.[0].link"
            target="_blank"
          >
            <img :src="linkItem.linkImage">
          </a>
          <div v-else-if="linkItem.socialMediaList && linkItem.socialMediaList.length > 1" style="height: 100%">
            <Tooltip contentWrapperStyle="height: 100%; display: flex" style="height: 100%">
              <template #title>
                <div style="display: flex">
                  <a
                    v-for="(item, subIndex) in linkItem.socialMediaList"
                    :key="`${item.link}_${subIndex}`"
                    v-at-navigation="`footer::social::${item.title}`"
                    class="sub-item-link"
                    :href="item.link"
                    target="_blank"
                  >
                    <span>{{ item.title }}</span>
                  </a>
                </div>
              </template>
              <img :src="linkItem.linkImage">
            </Tooltip>
          </div>
        </div>
      </div>
    </div>
    <Copyright />
  </div>
</template>

<script lang="ts">
import { defineComponent, reactive, toRefs, computed } from 'vue'
import UpDown from '../header/updown.vue'
import Copyright from './copyright.vue'
import { useStoreHooks } from '@/store/hook'
import { useRouter } from 'vue-router'
import { toServerUrl, getTenantMap } from '@/utils'
import { getAtModel, getLastNodeInUrl, DELAY_FOR_BURY_INFO } from '@/utils/atModel'
import Tooltip from '@/components/mobile/tooltip/index.vue'

interface IState {
  expandedKeys: string[]
  showCooperativePartner: boolean
}

export default defineComponent({
  components: {
    UpDown,
    Copyright,
    Tooltip
  },
  setup () {
    const router = useRouter()
    const { state: storeState, getters } = useStoreHooks()
    const state: IState = reactive({
      expandedKeys: [],
      showCooperativePartner: false
    })
    const isArSite = computed(() => storeState.global.isArSite)
    const links = storeState.global.footerConfig
    const isExpand = (key: string): boolean => {
      return !!state.expandedKeys.includes(key)
    }
    const getType = (key: string): number => {
      return state.expandedKeys.includes(key) ? 1 : 0
    }
    const onExpandMenu = (key: string) => {
      const index = state.expandedKeys.findIndex((k) => k === key)
      if (index < 0) {
        state.expandedKeys.push(key)
      } else {
        state.expandedKeys.splice(index, 1)
      }
    }
    const getLinks = (type: string): any[] => {
      const arr: any[] = []
      links.forEach((l: any) => {
        if (l.areaKind === type) {
          arr.push(l)
        }
      })
      return arr
    }
    const openUrl = (url: string, e: Event) => {
      getAtModel().doNavigationEvent(`footer::${getLastNodeInUrl(url)}`, e)
      setTimeout(() => {
        const urlReg = /[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\.?/
        const matched = urlReg.exec(url)
        console.log('checked', location.hostname, matched)
        if (matched && matched[0] && location.hostname === matched[0]) {
          // 同站点，本页面打开
          window.location.href = url
        } else {
          window.open(url)
        }
      }, DELAY_FOR_BURY_INFO)
    }
    const onToTrainer = (e: Event) => {
      getAtModel().doNavigationEvent('footer::trainer-team', e)
      router.push('/mobile/trainer-team')
    }
    const toMainPage = () => {
      toServerUrl('/', true)
    }
    const joinUs = () => {
      router.push('/mobile/join-us-as-a-trainer')
    }
    state.showCooperativePartner = getLinks('5').length > 0
    return {
      ...toRefs(state),
      isExpand,
      onExpandMenu,
      getType,
      getLinks,
      onToTrainer,
      openUrl,
      toMainPage,
      socialSiteUrl: computed(() => getters['global/socialLinks']),
      joinUs,
      tenantId: computed(() => storeState.global.tenantId),
      tenantMap: getTenantMap(),
      isArSite
    }
  }
})
</script>
<style lang="less" src="./index.less"></style>
